var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeam = function SvgTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.999,
    cy: 8.509,
    r: 3.491
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.003,
    cy: 9.499,
    r: 2.501
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.996 20.003v-1.017C1.996 16.785 3.78 15 5.981 15h4.035a3.984 3.984 0 0 1 3.985 3.985v1.017M17.002 15.001h1.103c2.2 0 3.985 1.784 3.985 3.985v1.017"
  }))));
};
export { SvgTeam as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiY2ZlYjQ5M2I0ZGRmNTVhNjAyMTc3MzRlMjk3MDVhMTkuc3ZnIjs=";